import React from "react";

import DoubtText from "./DoubtText";

import { Grid, Typography } from "@material-ui/core";

const UserDoubts = (props) => {

    return (
        <>
            <Grid container>
                <Typography
                    align="center"
                    style={{
                        fontSize: "32px",
                        color: "#6495ED",
                        fontWeight: "bold",
                        marginBottom: "5px",
                        padding: "10px"
                    }}
                >
                    User Doubts
                </Typography>
            </Grid>

            <Grid container>
                {
                    props?.doubts?.map((doubt, i) => {
                        return (
                            <DoubtText doubtID={doubt} key={i} />
                        )
                    })
                }
            </Grid>
        </>
    );
}

export default UserDoubts;